import { PaxType } from '@booking/entities/pax-type';
import { TravelerTypes, TravelerInfoType } from '@pax/entities/traveler-info';
import { PassengerType } from '@shared/base-search-bar/entities/passenger-arrangement';
import { TravelerPaxResponse, Loyalty, LoyaltyResponse } from '@pax/entities/traveler-pax';

export enum Identificators {
  DOCUMENT_ID = 'documentId',
  ID = '_id'
}

export enum TypeTabs{
  EXCHANGE = 'EXCHANGE',
  ACTUAL = 'ACTUAL'
}

export const PAX_TO_TRAVELER = {
  [PaxType.ADULTS]: TravelerTypes.ADULTS,
  [PaxType.CHILDREN]: TravelerTypes.CHILDREN,
  [PaxType.INFANTS]: TravelerTypes.INFANTS
};

export const PASSENGER_TO_TRAVELER = {
  [PassengerType.ADULTS]: TravelerTypes.ADULTS,
  [PassengerType.CHILDREN]: TravelerTypes.CHILDREN,
  [PassengerType.INFANTS]: TravelerTypes.INFANTS
};

export interface TravelerRoomUI {
  id: number;
  roomNumber: number;
  roomGuests: TravelerItemUI[];
}

export interface TravelerItemUI {
  id: number;
  TravelerInfoType: TravelerInfoType;
  TravelerType: TravelerTypes;
  OrdinalKey: string;
  OrdinalNumber: number;
  IndexTypeNumber: number;
  LinealOrdinalKey?: string;
  FareId?: number;
  defaultData?: TravelerPaxResponse;
}

export interface TravelerIdentifier {
  id: number;
  TravelerInfoType: TravelerInfoType;
  guestId?: number;
}

export interface LoyaltyCreateEvent {
  loyalty: Loyalty;
  create: boolean;
}

export interface LoyaltyUpdateEvent {
  loyalty: LoyaltyResponse;
  update: boolean;
}

export interface DocumentData {
  configuration_document_id: number;
  document_number: string;
  documentId: string;
}
